import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import LogType from './log-type-model'
import {
  CreateLogTypeAsync,
  DeleteLogTypeAsync,
  LoadLogTypesAsync,
} from './logType-thunk'
const initialState: logTypeSliceState = {
  logType: [],
  selected_logType: '',
  is_loading_logType: false,
  is_creating_logType: false,
  is_deleting_logType: false,
}
export interface logTypeSliceState {
  logType: LogType[]
  selected_logType?: string
  is_loading_logType: boolean
  is_creating_logType: boolean
  is_deleting_logType: boolean
}
export const logTypeSlice = createSlice({
  name: 'logType',
  initialState,
  reducers: {
    setSelectedlogType: (state, action) => {
      state.selected_logType = action.payload
    },
    clearStatelogType: (state) => {
      state.logType = []
      state.is_loading_logType = false
      state.is_creating_logType = false
      state.is_deleting_logType = false
    },
    mergelogType: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_logType = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.logType = merge(state.logType, payload) as any
        }
      }
    },

    add_logType: (state, action) => {
      if (action.payload) {
        state.logType = [...state.logType, action.payload]
      }
    },
    set_logType: (state, action) => {
      let { key, value, id } = action.payload
      state.logType = state.logType.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadLogTypesAsync.pending, (state) => {
      state.is_loading_logType = true
    })
    builder.addCase(LoadLogTypesAsync.fulfilled, (state, action) => {
      state.is_loading_logType = false
      if (action.payload) {
        state.logType = action.payload
      }
    })
    builder.addCase(LoadLogTypesAsync.rejected, (state) => {
      state.is_loading_logType = false
    })
    builder.addCase(CreateLogTypeAsync.pending, (state) => {
      state.is_creating_logType = true
    })
    builder.addCase(CreateLogTypeAsync.fulfilled, (state) => {
      state.is_creating_logType = false
    })
    builder.addCase(CreateLogTypeAsync.rejected, (state) => {
      state.is_creating_logType = false
    })
    builder.addCase(DeleteLogTypeAsync.pending, (state) => {
      state.is_deleting_logType = true
    })
    builder.addCase(DeleteLogTypeAsync.fulfilled, (state, action) => {
      state.is_deleting_logType = false
      if (state.logType) {
        state.logType = state.logType.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteLogTypeAsync.rejected, (state) => {
      state.is_deleting_logType = false
    })
  },
})

export const {
  clearStatelogType,
  setSelectedlogType,
  set_logType,
  mergelogType,
  add_logType,
} = logTypeSlice.actions

export const get_logType =
  (id?: string) =>
  (state: {
    logType: {
      logType: LogType[]
    }
  }): LogType | null => {
    let temp = state?.logType?.logType?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.logType?.logType[0] || null
  }
export const get_selected_logType = (state: {
  logType: logTypeSliceState
}): LogType | null => {
  let id = state?.logType?.selected_logType
  let temp = state?.logType?.logType?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_logType = (state: {
  logType: {
    logType: LogType[]
  }
}): LogType[] => {
  let temp = state?.logType?.logType
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_logType_busy = (state: { logType: logTypeSliceState }) => {
  return (
    state?.logType.is_deleting_logType ||
    state?.logType.is_loading_logType ||
    state?.logType.is_creating_logType
  )
}
export const is_deleting_logType_busy = (state: {
  logType: logTypeSliceState
}) => {
  return state?.logType.is_deleting_logType
}
export const is_loading_logType_busy = (state: {
  logType: logTypeSliceState
}) => {
  return state?.logType.is_loading_logType
}
export const is_creating_logType_busy = (state: {
  logType: logTypeSliceState
}) => {
  return state?.logType.is_creating_logType
}

export default logTypeSlice.reducer
